module.exports = __webpack_public_path__ + "img/alabama-ag-logo.fee7a359.jpg";